import { useQuery } from '@tanstack/react-query';
import Global from '../../../../../Services/Common/Global';
import { apiRequest } from '../../../../../Services/Common/ApiRequest';
import { mapParamsBySchema, mapRowsBySchema } from '../../../../../util';
import useSaveMutation from '../../../../../hooks/apis/useSaveMutaion';
import useDeleteMutation from '../../../../../hooks/apis/useDeleteMutaion';
import useSearchMutaion from '../../../../../hooks/apis/useSearchMutaion';
import { RiskAssessment_Schema } from './RiskAssessment_Schema';

/**
 * 위험성평가 실시 조회 — GetRisCustom02R1
 */
export const useSearch1 = (options = {}) => {
  const { rsCd, searchText = '', enabled = true } = options;
  return useQuery({
    queryKey: [
      'RiskEvaluation',
      'RiskAssessment',
      'getRisCustom02R1',
      rsCd,
      searchText,
    ],
    enabled: enabled !== false && Number(rsCd) > 0,
    queryFn: async () => {
      const params = mapParamsBySchema(RiskAssessment_Schema.mapper.search1, {
        rsCd,
        searchText,
      });
      return apiRequest(
        'post',
        Global.urls.RiskEvaluation.getRisCustom02R1,
        params
      );
    },
  });
};

/**
 * 위험성평가 실시 저장 — SaveRisCustom02U1
 * rows: [{ rsCd, sriId, userId?, items: [...] }]
 */
export const useSave1 = (options = {}) => {
  return useSaveMutation(
    async (rows) => {
      const list = mapRowsBySchema(rows, RiskAssessment_Schema.mapper.save1);
      const req = list?.[0] ?? {};
      return apiRequest(
        'post1',
        Global.urls.RiskEvaluation.saveRisCustom02U1,
        req
      );
    },
    options,
    false
  );
};

/**
 * 위험성평가 근로자 의견받기 기간 — SaveRisCustom02U2 (TB_BS_CUST)
 * body: SaveRisCustom02U2Request (CustCd/UserId 암호화)
 */
export const useSave2 = (options = {}) => {
  return useSaveMutation(
    async (body) =>
      apiRequest(
        'post1',
        Global.urls.RiskEvaluation.saveRisCustom02U2,
        body
      ),
    options,
    false
  );
};

/**
 * 위험성평가 실시 삭제 — DeleteRisCustom02D1
 * payload: { rsdCds: string[] } (또는 rsdCd 단건/배열)
 */
export const useDelete1 = (options = {}) => {
  // useDeleteN DeleteLogic에서 deleteMutation.runAsync([row]) 형태로 들어옴
  return useDeleteMutation(async (rows) => {
    const list = Array.isArray(rows) ? rows : [rows];
    const payload = mapRowsBySchema(list, RiskAssessment_Schema.mapper.delete1);
    return apiRequest('post', Global.urls.RiskEvaluation.deleteRisCustom02D1, payload);
  }, options);
};

/**
 * 표준모델 요인 조회 — GetRisBasic01R6 (RIS_BASIC_01 useSearch7과 동일)
 */
export const useSearch7 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      RiskAssessment_Schema.mapper.search7,
      context
    );
    return apiRequest(
      'post',
      Global.urls.RiskEvaluation.getRisBasic01R6,
      params
    );
  }, successOptions);
};
